import Vue from 'vue';
import MainPanel from '@/_shared/components/globals/main-panel.component.vue';
import Loading from '@/_shared/components/globals/loading.component.vue';
import PrismicVue from '@prismicio/vue';

Vue.use(PrismicVue, {});
Vue.component('main-panel', MainPanel);
Vue.component('loading', Loading);
